// Contract Start Date Values
export const ENECO_SME_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MIN = 1;
export const ENECO_SME_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_DEFAULT = 23;
export const ENECO_SME_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MAX = 90;

export const CONTRACT_CONSIDERATION_PERIOD_IN_DAYS = 14;

// Max Usage Values
export const ENECO_SME_ENERGY_FLOW_MAX_USAGE_VALUE_ELECTRICITY_HIGH = 100000;
export const ENECO_SME_ENERGY_FLOW_MAX_USAGE_VALUE_ELECTRICITY_LOW = 100000;
export const ENECO_SME_ENERGY_FLOW_MAX_USAGE_VALUE_GAS = 30000;
export const ENECO_SME_ENERGY_FLOW_MAX_USAGE_VALUE_WARMTH = 10000;
export const ENECO_SME_ENERGY_FLOW_MAX_USAGE_VALUE_WATER = 10000;

// Misc
export const SOLAR_PANEL_OUTPUT = 240;
